import {
  formatDate,
  MbscCalendarEvent,
  MbscDatepickerOptions,
  MbscEventcalendarOptions,
  MbscEventcalendarView,
  MbscPopup,
  MbscPopupOptions,
  MbscResource,
  setOptions,
  momentTimezone,
} from '@mobiscroll/angular';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  AbstractControl,
  Validators,
  ValidatorFn,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { appointments } from 'src/app/models/appointments.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { forkJoin } from 'rxjs';
import * as moment from 'moment-timezone';
import { Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {
  SLOT_CONFIG,
  WORKING_TIME_CONFIG,
} from 'src/app/config/calendar.config';

momentTimezone.moment = moment;

// function numericRangeValidator(min: number, max: number): Validators {
//   return (control: AbstractControl): Validators | null => {
//     if (!control.value && control.value !== 0) {
//       return null; // don't validate empty values to allow optional controls
//     }
//     const value = parseFloat(control.value);
//     if (isNaN(value) || value < min || value > max) {
//       return { 'numericRange': { value: control.value } };
//     }
//     return null;
//   };
// }
// import { AbstractControl, Validators } from '@angular/forms';

function numericRangeValidator(min: number, max: number): Validators {
  return (control: AbstractControl): Validators | null => {
    const value = control.value;

    // Check for empty values or non-numeric values (excluding 0)
    if (value === null || value === undefined || isNaN(value)) {
      return null; // don't validate empty or non-numeric values to allow optional controls
    }

    // Convert to number, including handling the case where the value is '0'
    const numericValue = parseFloat(value);

    // Check if the numeric value is within the specified range
    if (isNaN(numericValue) || numericValue < min || numericValue > max) {
      return { numericRange: { value: control.value } };
    }

    return null;
  };
}

function maxDigitsValidator(maxDigits: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    const isValid = value === null || value.toString().length <= maxDigits;
    return isValid ? null : { maxDigits: { max: maxDigits } };
  };
}

const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

declare var jQuery: any;

@Component({
  selector: 'app-create-appointment',
  templateUrl: './create-appointment.component.html',
  styleUrls: ['./create-appointment.component.scss'],
})
export class CreateAppointmentComponent implements OnInit {
  modalDisabled: boolean = true;
  assessmentDate: any;
  show: boolean = false;
  diagnosticians: any;
  paymentAmount: any;
  paymentStatus: any;
  paymentResponse: any = {};
  locationName: any;
  appointmentComments: String = '';
  diagAvailable: boolean = true;
  testAmount: any;
  parentNamePlaceholder: string = 'Parent Name (Optional)';
  isSaving: boolean = false;
  paymentPending: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private router: Router,
    private auth: AuthenticationService,
    private appointmentService: AppointmentService
  ) {}

  locations: any;
  locationId: any = '';
  @ViewChild('popup', { static: false })
  popup!: MbscPopup;
  @ViewChild('colorPicker', { static: false })
  colorPicker: any;
  popupEventTitle: string | undefined;
  popupEventDescription = '';
  popupEventAllDay = true;
  popupEventDates: any;
  todayDate: any;
  selectTimeSlots = 'slot1';
  calendarSelectedDate: any = new Date();
  switchLabel: any = 'All-day';
  tempColor = '';
  selectedColor = '';
  tempEvent!: MbscCalendarEvent;
  appointmentStartTime!: string;
  appointmentEndTime!: string;
  appointmentTime!: string;
  testTypes: any = [];
  schoolType: any;
  ifloaded: boolean = false;
  AppointmentForm!: FormGroup;
  parentDetailsForm!: FormGroup;
  paymentDepositForm!: FormGroup;
  selectedDiag: any = '';
  reset: any = 'Close';
  clickToCreate: any = 'single';
  resourceName: any;
  appointmentDetails: any = {};
  appointmentId!: number;
  clientId!: number;
  selectedTime: any;
  displayErrorMessage: string = '';

  calendarOptions: MbscEventcalendarOptions = {
    clickToCreate: this.clickToCreate,
    dragToCreate: true,
    dragToMove: false,
    dragToResize: false,
    view: {
      schedule: {
        type: 'week',
      },
    },
    timezonePlugin: momentTimezone,
    dataTimezone: 'utc',
    displayTimezone: 'America/Chicago',
    responsive: {
      medium: {
        dragToCreate: false,
      },
    },

    onEventClick: (args) => {
      this.isEdit = true;
      this.tempEvent = args.event;
      // fill popup form with event data
      if (this.tempEvent.title == 'New event') {
        this.loadPopupForm(args.event);
        // set popup options
        this.popupHeaderText = 'Edit event';
        this.popupButtons = this.popupEditButtons;
        this.popupAnchor = args.domEvent.currentTarget;
        // open the popup
        this.popup.open();
      }
    },
    onEventCreated: (args) => {
      setTimeout(() => {
        this.isEdit = false;
        this.tempEvent = args.event;
        this.selectedTime = this.tempEvent.start;

        this.loadPopupForm(args.event);
        // set popup options
        this.popupHeaderText = 'New Event';
        this.popupButtons = this.popupAddButtons;
        this.popupAnchor = args.target;
        // open the popup
        this.popup.open();
        // }
      });
    },
    onEventDeleted: (args) => {
      setTimeout(() => {
        this.deleteEvent(args.event);
      });
    },
    onEventUpdated: (args) => {
      // here you can update the event in your storage as well, after drag & drop or resize
      // ...
    },
  };
  popupHeaderText!: string;
  popupAnchor: HTMLElement | undefined;
  popupAddButtons = [
    'cancel',
    {
      handler: () => {
        this.saveEvent();
      },
      keyCode: 'enter',
      text: 'Save',
      cssClass: 'mbsc-popup-button-primary',
    },
  ];
  popupEditButtons = [
    'cancel',
    {
      handler: () => {
        this.saveEvent();
      },
      keyCode: 'enter',
      text: 'Save',
      cssClass: 'mbsc-popup-button-primary',
    },
  ];
  popupButtons: any = [];
  popupOptions: MbscPopupOptions = {
    display: 'bottom',
    contentPadding: false,
    fullScreen: false,
    onClose: () => {
      if (!this.isEdit) {
        // refresh the list, if add popup was canceled, to remove the temporary event
        this.myEvents = [...this.myEvents];
      }
    },
    responsive: {
      xsmall: {
        display: 'anchored',
        touchUi: true,
      },
    },
  };
  datePickerControls = ['date'];
  datePickerResponsive: any = {
    xsmall: {
      controls: ['time'],
      touchUi: false,
    },
  };
  datetimePickerControls = ['time'];
  datetimePickerResponsive = {
    xsmall: {
      controls: ['calendar', 'time'],
      touchUi: false,
    },
  };
  datePickerOptions: MbscDatepickerOptions = {
    min: new Date(), // set the minimum date to today
    select: 'range',
    showRangeLabels: false,
    touchUi: true,
  };
  isEdit = false;

  loadPopupForm(event: MbscCalendarEvent): void {
    this.diagnosticians.data.forEach(
      (element: { id: string | number; firstName: any; lastName: any }) => {
        if (element.id == this.tempEvent.resource) {
          this.resourceName = element.firstName + ' ' + element.lastName;
        }
      }
    );
    this.popupEventTitle = event.title;
    this.popupEventDescription = event['description'];
    this.popupEventDates = [event.start, event.end];
    this.popupEventAllDay = event.allDay || false;
    let chicagoTime = new Date(
      new Date(event.start as Date).toLocaleString('en-US', {
        timeZone: 'America/Chicago',
      })
    );
    let hours = chicagoTime.getHours();
    if (
      hours >= SLOT_CONFIG.slot1.start.hour &&
      hours < SLOT_CONFIG.slot1.end.hour
    ) {
      this.selectTimeSlots = 'slot1';
    } else {
      this.selectTimeSlots = 'slot2';
    }
    this.selectedColor = event.color || '';
  }

  saveEvent(): void {
    this.tempEvent.title = this.popupEventTitle;
    this.tempEvent['description'] = this.popupEventDescription;
    this.tempEvent.start = this.popupEventDates[0];

    this.tempEvent.end = this.popupEventDates[1];
    this.tempEvent.allDay = this.popupEventAllDay;
    this.tempEvent.slot = this.selectTimeSlots;

    const d = new Date(this.tempEvent.start as Date);

    let year = d.getFullYear();
    let monthName = monthNames[d.getMonth()];
    let day = d.getDate();

    this.assessmentDate = monthName + ' ' + day + ', ' + year;

    if (this.tempEvent.slot == 'slot1') {
      var start = new Date(this.tempEvent.start as Date);
      start.setDate(start.getDate());
      start.setHours(SLOT_CONFIG.slot1.start.hour);
      start.setMinutes(0);
      start.setMilliseconds(0);
      this.tempEvent.start = start;
      var end = new Date(this.tempEvent.end as Date);
      end.setDate(start.getDate());
      end.setHours(SLOT_CONFIG.slot1.end.hour);
      end.setMinutes(0);
      end.setMilliseconds(0);
      this.tempEvent.end = end;
      this.appointmentTime =
        SLOT_CONFIG.slot1.start.timeFormatted +
        ' - ' +
        SLOT_CONFIG.slot1.end.timeFormatted;
    } else if (this.tempEvent.slot == 'slot2') {
      var start = new Date(this.tempEvent.start as Date);
      start.setDate(start.getDate());
      start.setHours(SLOT_CONFIG.slot2.start.hour);
      start.setMinutes(0);
      start.setMilliseconds(0);
      this.tempEvent.start = start;
      var end = new Date(this.tempEvent.end as Date);
      end.setDate(start.getDate());
      end.setHours(SLOT_CONFIG.slot2.end.hour);
      end.setMinutes(0);
      end.setMilliseconds(0);
      this.tempEvent.end = end;
      this.appointmentTime =
        SLOT_CONFIG.slot2.start.timeFormatted +
        ' - ' +
        SLOT_CONFIG.slot2.end.timeFormatted;
    }

    this.tempEvent.color = this.selectedColor;
    if (this.isEdit) {
      // update the event in the list
      this.myEvents = [...this.myEvents];
      // here you can update the event in your storage as well
      // ...
    } else {
      // add the new event to the list
      this.myEvents = [...this.myEvents, this.tempEvent];
      // here you can add the event to your storage as well
      // ...
    }
    // navigate the calendar
    this.calendarSelectedDate = this.popupEventDates[0];
    this.reset = 'Reset';
    this.clickToCreate = '';

    // close the popup
    this.popup.close();
  }
  deleteEvent(event: MbscCalendarEvent): void {
    if (this.reset == 'Reset') {
      this.myEvents = this.myEvents.filter((item) => item.id !== event.id);
      this.reset = 'Close';
      this.assessmentDate = '';
      this.appointmentTime = '';
      this.clickToCreate = 'single';
    }

    // here you can delete the event from your storage as well
    // ...
  }
  onDeleteClick(): void {
    if (this.reset == 'Reset') {
      this.deleteEvent(this.tempEvent);
      this.popup.close();
    }
  }

  view: MbscEventcalendarView = {
    schedule: {
      type: 'week',
      allDay: false,
      startDay: 1,
      endDay: 7,
      startTime: WORKING_TIME_CONFIG.start,
      endTime: WORKING_TIME_CONFIG.end,
    },
  };

  myEvents: MbscCalendarEvent[] = [];

  invalid = [
    {
      start: '0001-01-00',
      end: new Date(new Date().setDate(new Date().getDate() - 1)),
    },
  ];

  myResources: any[] = [];

  formatDate = formatDate;
  events: any;

  selectLocation() {
    this.myEvents = [];
    this.calendarSelectedDate = new Date();
    this.invalid = [
      {
        start: '0001-01-00',
        end: new Date(new Date().setDate(new Date().getDate() - 1)),
      },
    ];
    if (this.tempEvent) {
      this.onDeleteClick();
    }
    this.show = false;
    this.spinner.show();

    let i = 0;
    let userType = 1002;
    this.myResources = [];
    this.locations.data.forEach((element: { id: any; name: any }) => {
      if (element.id == this.locationId) {
        this.locationName = element.name;
      }
    });

    forkJoin({
      // requestOne: this.appointmentService
      //   .getUser(this.locationId, userType),
      requestOne: this.appointmentService.getUserV2(this.locationId, userType),
      requestTwo: this.appointmentService.getDiagUnavailability(
        null,
        this.locationId,
        userType
      ),
      requestThree: this.appointmentService.getAppointments(
        this.locationId,
        null,
        'ALL',
        null,
        null,
        null
      ),
    }).subscribe(({ requestOne, requestTwo, requestThree }) => {
      this.diagnosticians = requestOne;
      if (requestOne.data.length == 0) {
        this.modalDisabled = true;
        this.diagAvailable = false;
        this.show = true;

        this.spinner.hide();
      } else {
        this.modalDisabled = false;
        this.diagAvailable = true;

        this.diagnosticians.data.forEach((element: any) => {
          let requestOne = {
            id: element.id,
            name: element.firstName + ' ' + element.lastName,
            // img: 'https://img.mobiscroll.com/demos/m2.png',
          };
          this.myResources.push(requestOne);
        });
        this.AppointmentForm.controls['locationId'].updateValueAndValidity();
        this.events = requestTwo;
        // this.invalid = this.events.data;
        this.events.data.forEach((element: any) => {
          this.invalid.push(element);
        });
        this.events.dataRec.forEach((element: any) => {
          this.invalid.push(element);
        });
        requestThree.data.forEach((element: any) => {
          let appt = element.appointmentDetails.schedules[0];
          if (appt.status != 'CANCEL') {
            this.myEvents.push(appt);
          }
        });

        this.show = true;
        this.spinner.hide();
      }
    });
  }

  ngOnInit(): void {
    this.calendarSelectedDate = new Date();
    this.spinner.show();

    forkJoin({
      requestOne: this.appointmentService.getLocations(),
      requestTwo: this.appointmentService.getTestTypes(),
      requestThree: this.appointmentService.getSchoolType(),
    }).subscribe(
      ({ requestOne, requestTwo, requestThree }) => {
        this.locations = requestOne;

        //this.testTypes = requestTwo.data.filter(value => this.shouldDisplayValue(value));

        this.testTypes = requestTwo.data;

        this.schoolType = requestThree.data;
        this.spinner.hide();
        this.ifloaded = true;
      },
      (err) => {
        this.spinner.hide();
      }
    );

    this.AppointmentForm = this.formBuilder.group({
      locationId: ['', Validators.required],
      assesmentId: ['', Validators.required],
      start: [''],
      end: [''],
      diagnosticianId: [''],
      appointmentDate: [this.assessmentDate, Validators.required],
      appointmentTime: [this.appointmentTime, Validators.required],
      resource: [''],
      slot: [''],
      assesmentComments: [''],
      appointmentComments: [this.appointmentComments],
    });
    let emailPattern = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
    this.parentDetailsForm = this.formBuilder.group({
      parentName: [''],
      studentLastName: ['', Validators.required],
      studentFirstName: ['', Validators.required],
      nickName: [''],
      schoolType: ['', Validators.required],
      school: [''],
      secondaryEmailAddress: ['', [Validators.pattern(emailPattern)]],
      phoneNumber: [''],
      dateOfBirth: ['', [Validators.required, this.pastDateValidator()]],
      grade: ['', Validators.required],
      cellNumber: ['', Validators.required],
      emailAddress: [
        '',
        [Validators.required, Validators.pattern(emailPattern)],
      ],
      reasonForCall: ['', Validators.required],
      address1: [''],
      address2: [''],
      city: [''],
      state: ['', [this.stateValidator]],
      zipCode: ['', [this.zipCodeValidator]], //
      appointmentTestAmount: [
        '',
        [
          Validators.required,
          numericRangeValidator(1, 10000),
          maxDigitsValidator(4),
        ],
      ],
    });

    this.paymentDepositForm = this.formBuilder.group({
      paymentAmount: [
        null,
        [
          Validators.required,
          numericRangeValidator(0, 10000),
          maxDigitsValidator(4),
        ],
      ],
    });
  }
  diagnosticianAvailabilityValidator(
    control: FormControl
  ): { [key: string]: boolean } | null {
    if (this.diagAvailable === false) {
      return { noDiagnostician: true };
    }
    return null;
  }
  stateValidator(control: FormControl): { [key: string]: boolean } | null {
    const isValid = /^[a-zA-Z ]*$/.test(control.value);
    if (!isValid) {
      return { invalidState: true };
    }
    return null;
  }
  zipCodeValidator(control: FormControl): Validators | null {
    if (!control.value) {
      // If the value is empty or undefined, consider it valid (non-mandatory)
      return null;
    }
    const isValidZip = /^\d{5}$/.test(control.value);
    if (!isValidZip) {
      return { invalidZip: true };
    }
    return null;
  }
  checkForInvalidCharacters(event: any) {
    const value = event.target.value;

    if (isNaN(value)) {
      // Handle the case where the value is not a number
      this.displayErrorMessage = 'Please enter a valid number.';
      return;
    }

    // Example: Check for a specific range, e.g., 1 to 10000
    const minValue = 1;
    const maxValue = Number.MAX_SAFE_INTEGER;
    if (value < minValue || value > maxValue) {
      this.displayErrorMessage = `Please enter a valid number.`;
      return;
    }

    // Reset the error message if the input is valid
    this.displayErrorMessage = '';
  }
  pastDateValidator(): Validators {
    return (control: FormControl): { [key: string]: any } | null => {
      const inputDate = control.value ? new Date(control.value) : null;
      const currentDate = new Date();
      if (inputDate && inputDate > currentDate) {
        return { futureDate: true };
      }
      return null;
    };
  }

  submitForm() {
    this.spinner.show();
    this.AppointmentForm.controls['diagnosticianId'].setValue(
      this.tempEvent.resource
    );
    this.AppointmentForm.controls['appointmentComments'].setValue(
      this.appointmentComments
    );

    this.AppointmentForm.controls['resource'].setValue(this.tempEvent.resource);
    if (this.tempEvent.slot == 'slot1') {
      this.AppointmentForm.controls['slot'].setValue(1);
    } else if (this.tempEvent.slot == 'slot2') {
      this.AppointmentForm.controls['slot'].setValue(2);
    }
    var startDate = new Date(this.tempEvent.start as Date);
    // var userTimezoneOffset = startDate.getTimezoneOffset() * 60000;
    // startDate = new Date(startDate.getTime() - userTimezoneOffset);

    var endDate = new Date(this.tempEvent.end as Date);
    // var userTimezoneOffset = endDate.getTimezoneOffset() * 60000;
    // endDate = new Date(endDate.getTime() - userTimezoneOffset);
    this.AppointmentForm.controls['start'].setValue(startDate);
    this.AppointmentForm.controls['end'].setValue(endDate);

    this.appointmentDetails['appointmentDetails'] = this.AppointmentForm.value;
    this.appointmentDetails['parentDetails'] = this.parentDetailsForm.value;

    this.appointmentService
      .createAppointment(this.appointmentDetails)
      .subscribe(
        (res: any) => {
          if (res.code == '500') {
            this.spinner.hide();
            return;
          }
          this.spinner.hide();
          // Set flag to indicate that payment is pending
          this.paymentPending = true;
          jQuery('#paymentModal').modal('show');
          this.testAmount = res.data.totalAmount;
          this.clientId = res.data.clientId;
          this.appointmentId = res.data.appointmentId;
        },
        (err) => {
          this.spinner.hide();
        }
      );
  }
  get f() {
    return this.parentDetailsForm.controls;
  }

  get pf() {
    return this.paymentDepositForm.controls;
  }

  get af() {
    return this.AppointmentForm.controls;
  }

  submitPayment() {
    this.spinner.show();
    this.paymentStatus = 'submitted';
    let date = new Date();
    let details = {
      bookingAmount: this.paymentDepositForm.get('paymentAmount')?.value ?? 0,
      bookingStatus: this.paymentStatus,
      bookingDate: date.toLocaleDateString(),
    };
    this.appointmentService
      .submitPaymentDetails(details, this.clientId, this.appointmentId)
      .subscribe(
        (res: any) => {
          // Payment processing successful
          this.paymentPending = false; // Reset flag when payment is complete
          this.paymentResponse = res.data;
          // alert('Payment Successful!');
          this.spinner.hide();
          jQuery('#appointmentScheduled').modal('show');
        },
        (error) => {
          // Payment processing failed
          this.paymentPending = true; // Keep the flag true as payment failed
          alert('Payment Failed. Please try again.');
          // Hide the loading spinner
          this.spinner.hide();
        }
      );
  }

  onGradeChange(deviceValue: string) {
    if (deviceValue == 'Adult' || deviceValue == 'College') {
      this.parentNamePlaceholder = 'Parent Name (Optional)';
      this.parentDetailsForm.controls['parentName'].removeValidators([
        Validators.required,
      ]);
      this.parentDetailsForm.controls['parentName'].updateValueAndValidity();
    } else {
      this.parentNamePlaceholder = 'Parent Name';
      this.parentDetailsForm.controls['parentName'].setValidators([
        Validators.required,
      ]);
      this.parentDetailsForm.controls['parentName'].touched;
      this.parentDetailsForm.controls['parentName'].errors;
      this.parentDetailsForm.controls['parentName'].updateValueAndValidity();
    }
  }

  shouldDisplayValue(value: any): boolean {
    return !value.name.startsWith('Online');
  }
}
